<template>
  <transition name="slide-fade">
    <div class="uk-padding" style="min-height: 100vh !important;">
      <div class="uk-container uk-container-small">

        <article class="uk-article">

          <h1 class="uk-article-title uk-text-center specHeading">{{ loadArticle.title.rendered }}</h1>


          <div v-html="loadArticle.content.rendered">
          </div>
          <p class="uk-article-meta">Written by <a href="#">{{ loadArticle.acf.author_name }}</a> </p>
          <div class="hello">
            <h4 class="uk-heading-bullet">Share To:</h4>
            <facebook :url="url"  scale="2"></facebook>
            <twitter :url="url" :title="loadArticle.title.rendered" scale="2"></twitter>
            <linkedin :url="url"  scale="2"></linkedin>
            <telegram :url="url" :title="loadArticle.title.rendered" scale="2"></telegram>
            <whats-app :url="url"  :title="loadArticle.title.rendered" scale="2"></whats-app>
            <email :url="url" :title="loadArticle.title.rendered" :subject="loadArticle.title.rendered" :body="loadArticle.content.rendered" scale="2"></email>
          </div>

        </article>
      </div>
    </div>
  </transition>
</template>

<script>
  import {
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Reddit,
    Telegram,
    WhatsApp,
    Email,
    Google
  } from "vue-socialmedia-share";
    export default {
        name: "featurestory",
      components: {
        Facebook,
        Twitter,
        Linkedin,
        Pinterest,
        Reddit,
        Telegram,
        WhatsApp,
        Email,
        Google
      },
      data() {
        return {
          url: "https://www.ncu.edu.jm" + this.$route.fullPath
        };
      },

      computed: {
        loadArticle: function () {
          //console.log(this.$store.state.featureStory)
          return this.$store.state.FeatureStory
        },
        returnUrl: function () {
          console.log()
          return  this.$route.query.page
        }
      },
      mounted(){
        //this.url = this.$route.query.page
        console.log(typeof this.$route.query.page)
      },
      created(){
        this.$store.state.FeatureStory = {}

        /*},
        mounted(){*/
        //console.log(this.$store.state.viewArticle)
        window.scrollTo(0, 0);
        this.$store.dispatch('getFeature', {featureID: this.$route.query.article})
      }
    }
</script>

<style scoped>
  .video-responsive{
    overflow:hidden;
    padding-bottom:76.25%;
    position:relative;
    height:0;
  }
  .video-responsive iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
  }
  .hello > span {
    padding: 1em;
  }
</style>
